import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { LibMenuService } from 'ngx-mat-base-comp';
import { DynamicFormsModule } from 'ngx-mat-dyn-form';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { KendoModule } from 'src/app/kendo/kendo.module';
import { MaterialModule } from 'src/app/material/material.module';
import { BarcodeComponent } from './component/barcode/barcode.component';
import { ClientPeriodComponent } from './component/client-period/client-period.component';
import { PhotoManagerComponent } from './component/photo-manager/photo-manager.component';
import { ReferenceDocumentsComponent } from './component/reference-documents/item-reference-document.component';
import { ItemReferenceDocumentDetailComponent } from './component/reference-documents/reference-documents-detail/item-reference-document-detail.component';
import { LibBaseComponentModule } from './lib-base-comp.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};



@NgModule({
  declarations: [
    BarcodeComponent,
    ReferenceDocumentsComponent,
    ItemReferenceDocumentDetailComponent,
    ClientPeriodComponent,
    PhotoManagerComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    KendoModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RxReactiveFormsModule,
    DynamicFormsModule,
    LibBaseComponentModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    KendoModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    TranslateModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    DynamicFormsModule,
    LibBaseComponentModule,
    BarcodeComponent,
    ReferenceDocumentsComponent,
    ItemReferenceDocumentDetailComponent,
    ClientPeriodComponent
  ],
  providers: [
    LibMenuService,
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
   ]
  })
export class SharedModule { }
